import { render, staticRenderFns } from "./activitiesCreate.vue?vue&type=template&id=3ab8113b"
import script from "./activitiesCreate.ts?vue&type=script&lang=ts&external"
export * from "./activitiesCreate.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports